import React, { useEffect, useRef } from 'react';
import { useNotifications } from './use-notifications.js';

function formatRelativeTime(isoString) {
  if (!isoString) return '';
  const diff = Date.now() - new Date(isoString).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

function DropdownNotification() {
  const {
    notifications,
    count,
    isOpen,
    isLoading,
    toggle,
    close,
    handleClick,
    handleClearAll,
  } = useNotifications();

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        close();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, close]);

  return (
    <li
      className={`nav-item nav-icon-hover-bg rounded-circle${isOpen ? ' show' : ''}`}
      ref={dropdownRef}
      style={{ position: 'relative' }}
    >
      <button
        type="button"
        className="nav-link nav-icon-hover text-white border-0 bg-transparent"
        onClick={toggle}
        aria-expanded={isOpen}
        aria-label="Notifications"
      >
        <i className="ti ti-bell"></i>
        {count > 0 ? (
          <span
            className="badge bg-danger rounded-pill position-absolute"
            style={{ top: '2px', right: '2px', fontSize: '0.6rem', minWidth: '16px', padding: '2px 4px' }}
          >
            {count > 99 ? '99+' : count}
          </span>
        ) : null}
      </button>

      {isOpen ? (
        <div
          className="dropdown-menu dropdown-menu-end show"
          style={{ minWidth: '320px', maxHeight: '400px', overflowY: 'auto', right: 0, left: 'auto' }}
        >
          <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
            <span className="fw-semibold">Notifications {count > 0 ? `(${count})` : ''}</span>
            {notifications.length > 0 ? (
              <button
                type="button"
                className="btn btn-link btn-sm text-danger p-0"
                onClick={handleClearAll}
              >
                Clear all
              </button>
            ) : null}
          </div>

          {isLoading ? (
            <div className="text-center py-3 text-muted">Loading…</div>
          ) : notifications.length === 0 ? (
            <div className="text-center py-3 text-muted">No notifications</div>
          ) : (
            notifications.map((n) => (
              <button
                key={n.uid}
                type="button"
                className="dropdown-item d-flex flex-column align-items-start px-3 py-2 border-bottom"
                onClick={() => handleClick(n)}
                style={{ whiteSpace: 'normal', cursor: 'pointer' }}
              >
                <span className="fw-semibold" style={{ fontSize: '0.85rem' }}>{n.title}</span>
                <span className="text-muted" style={{ fontSize: '0.75rem' }}>{formatRelativeTime(n.createdAt)}</span>
              </button>
            ))
          )}
        </div>
      ) : null}
    </li>
  );
}

export default DropdownNotification;
